import {actions as ACTION, mutations as MUTATION} from "./types";
import { PRODUCT_FILTER } from "@/contants/productAssignment";
import {Api, ApiUrl} from "@/services";

const uniqueArrayOfObjects = (array) => {
  const uniqueIds = new Set();
  return array.filter((item) => {
    const isNotDuplicate = !uniqueIds.has(item.id);
    uniqueIds.add(item.id);
    return isNotDuplicate;
  })
}

const notFoundInList = (item, list) => {
  return !list.find((listItem) => listItem.id === item.id);
}

const saveList = (params) => {
  const {data, list} = params;
  const cachedList = [];

  for (const item of data) {
    const isNotInStore = notFoundInList(item, list);
    if (isNotInStore) cachedList.push(item);
  }
  list.push(...cachedList);
};

const saveProducts = (params) => {
  const {filter_id, products, endCursor, list, fetched} = params;
  const cachedList = [];
  const productObj = list.find((item) => item.filter_id === filter_id);

  if (productObj) {
    for (const product of products) {
      const isNotInStore = notFoundInList(product, productObj.list);
      if (isNotInStore) cachedList.push(product);
    }
    productObj.endCursor = endCursor;
    productObj.fetched = fetched;
    productObj.list.push(...cachedList);
    return;
  };

  const item = {
    filter_id: filter_id,
    endCursor: endCursor,
    list: products,
    fetched: fetched
  }

  list.push(item);
};

const actions = {
  [ACTION.GET_PRODUCTS]({ state, commit }, params) {
    return new Promise(async (resolve, reject) => {
      try {

        const { list, queryList, endCursor, endCursorQuery } = state.product.all;
        const { query, page_id, refresh, changeQuery } = params;
        const isQuery = query.length !== 0;
        
        let payload = {
          s: query,
          pageId: page_id,
          refresh,
          nextCursor: isQuery ? endCursorQuery : endCursor,
          assignedOnly: isQuery ? (changeQuery ? true : state.assignedOnlyQuery) : state.assignedOnly
        }

        const res = await Api.base.get(ApiUrl.base.newAssignment.getBy[PRODUCT_FILTER.ALL], {
          params: payload
        });

        const { products, pageInfo } = res.data;

        state[ isQuery ? 'assignedOnlyQuery' : 'assignedOnly' ] = pageInfo?.hasNextAssignmentOnly;

        const uniqueListProducts = uniqueArrayOfObjects(products);

        const isFetchedAll = !pageInfo?.hasNextPage;

        if (isQuery) {
          if (isFetchedAll) commit(MUTATION.SET_FETCHED_ALL_QUERY, PRODUCT_FILTER.ALL);
          state.product.all.endCursorQuery = pageInfo?.hasNextPage && pageInfo?.endCursor || '';
          changeQuery
            ? state.product.all.queryList = uniqueListProducts
            : saveList({ data: uniqueListProducts, list: queryList });
        } else {
          if (isFetchedAll) commit(MUTATION.SET_FETCHED_ALL, PRODUCT_FILTER.ALL); 
          state.product.all.endCursor = pageInfo?.endCursor;
          saveList({ data: uniqueListProducts, list: list });
        }

        resolve(res.data);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        reject(e);
      }
    });
  },
  [ACTION.GET_LIST_BY_FILTER]({ state, commit }, params) {
    return new Promise(async (resolve, reject) => {
      try {
        const {query, page_id, filter, refresh, changeQuery} = params;
        const { list, queryList, endCursor, endCursorQuery } = state.product[filter];
        const isQuery = query.length !== 0;

        const res = await Api.base.get(ApiUrl.base.newAssignment.getBy[filter].list, {
          params: {
            refresh,
            s: query, 
            pageId: page_id,
            nextCursor: isQuery ? endCursorQuery : endCursor
          }
        });
        
        const { pageInfo } = res.data;
        const data = filter === PRODUCT_FILTER.PAGES ? res.data.productPages : res.data.collections;

        const isFetchedAll =  !data || data.length == 0 || data.length < 20 || !pageInfo?.hasNextPage;

        if (isQuery) {
          if (isFetchedAll) commit(MUTATION.SET_FETCHED_ALL_QUERY, filter);
          state.product[filter].endCursorQuery = pageInfo?.endCursor;
          changeQuery
            ? state.product[filter].queryList = data
            : saveList({data: data, list: queryList});
        } else {
          if (isFetchedAll) commit(MUTATION.SET_FETCHED_ALL, filter);
          state.product[filter].endCursor = pageInfo?.endCursor;
          saveList({data: data, list: list});
        }
        
        resolve(res.data);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        reject(e);
      }
    });
  },
  [ACTION.GET_PRODUCTS_BY_FILTER]({ state }, params) {
    return new Promise(async (resolve, reject) => {
      try {
        const {id, filter} = params;
        const producstByFilter = state.product[filter].products;
        const expandedList = producstByFilter.find((item) => item.filter_id === id);

        const res = await Api.base.get(ApiUrl.base.newAssignment.getBy[filter].products, {params: {
          [filter === 'pages' ? 'pageId' : 'collectionId']: id,
          nextCursor: expandedList?.endCursor || ''
        }});
        const { products } = res.data;

        const isFetchedAll =  
          !products 
          || (products.length == 0 && !res.data?.pageInfo?.hasNextPage)
          || !res.data?.pageInfo?.hasNextPage;

        const payload = {
          products: uniqueArrayOfObjects(products),
          filter_id: id,
          list: producstByFilter,
          fetched: isFetchedAll,
          endCursor: res.data?.pageInfo?.endCursor,
        }
        saveProducts(payload);
        resolve(res.products);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
        reject(error);
      }
    })
  },
  [ACTION.UPDATE_PAGE_ASSIGNMENT]({ state }, params) {
    return new Promise(async (resolve, reject) => {
      const { pageId } = params;
      const { selected, unselected } = state.product.assignment;
      try {
        const payload = {
          assignedIds: selected,
          unassignedIds: unselected
        };
        if (window._webSocket && window._webSocket.connection.readyState === 1) {
          payload.isUseSocket = true
        }
        const res =  await Api.base.post(ApiUrl.base.newAssignment.updatePageAssignment(pageId), payload);

        resolve(res.data);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        reject(e);
      }
    });
  },
};
export default actions;
